import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../shared/Header";
import Footer from "../shared/Footer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Select from "react-select";
import { AppointmentContext } from "../context/AppointmentContext";
import { PulseLoader } from "react-spinners";
import config from "../config";
import * as Yup from "yup";
import { mapFormToPayload } from "./mapFormToPayload";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendarAlt } from "react-icons/fa";
import { FaCircleInfo } from "react-icons/fa6";
import { FaEye } from "react-icons/fa";

import Swal from "sweetalert2";
import { generateOneTimeToken } from "../utils/authToken";
function AddPatient() {
  // Context, navigation, and state declarations
  const navigate = useNavigate();
  const { hospitalName } = useContext(AppointmentContext);
  const selectHospital = sessionStorage.getItem("selectedHospital");
  const selectedDoctor = JSON.parse(
    sessionStorage.getItem("selectedDoctor") || "{}",
  );
  const doctorName = selectedDoctor?.name || "";
  const [helpers, setHelpers] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [disabledFields, setDisabledFields] = useState({});
  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [permanentStateOptions, setPermanentStateOptions] = useState([]);
  const [permanentCityOptions, setPermanentCityOptions] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [mode, setMode] = useState("edit");
  const [bookingDate, setBookingDate] = useState(
    sessionStorage.getItem("SELECTED_DATE") || "",
  );
  const [fileSelected, setFileSelected] = useState(false);
  const [cameraOn, setCameraOn] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);
  const [payment, setPayment] = useState({});
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [showPayNow, setShowPayNow] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(false);
  const [payNowLoadingId, setPayNowLoadingId] = useState(null);
  const [bookingAmountInfo, setBookingAmountInfo] = useState(null);
  const [uploadedDocs, setUploadedDocs] = useState({});
  const [isPaying, setIsPaying] = useState(false);

  useEffect(() => {
    if (selectedOrder === null) {
      sessionStorage.removeItem("SELECTED_DATE");
      sessionStorage.removeItem("SELECTED_DEPARTMENT");
      sessionStorage.removeItem("SELECTED_DEPARTMENT_ID");
      sessionStorage.removeItem("selectedDoctor");
      sessionStorage.removeItem("selectedDoctorCode");
      sessionStorage.removeItem("selectedUHID");
    }
  }, [selectedOrder]);

  // Helper to get a new form object
  const getEmptyForm = () => ({
    salutation: "",
    name: "",
    religion: "",
    caste: "",
    nationality: "",
    occupation: "",
    monthlyIncome: "",
    phone: sessionStorage.getItem("loginMobile") || "",
    countryCode: "91",
    dob: "",
    gender: "",
    email: "",
    capturedImage: "",
    presentAddress: {
      address: "",
      policeStation: "",
      city: "",
      cityDistrict: "",
      country: "",
      state: "",
      pinCode: "",
    },
    permanentAddress: {
      address: "",
      policeStation: "",
      city: "",
      cityDistrict: "",
      country: "",
      state: "",
      pinCode: "",
    },
    sameAsPresent: true,
    relatives: [{ salutation: "", name: "", relation: "", phone: "" }],
    bookingCategory: "Private",
    bookingDate: sessionStorage.getItem("SELECTED_DATE") || "",
    department: sessionStorage.getItem("SELECTED_DEPARTMENT_ID") || "",
    department_name: sessionStorage.getItem("SELECTED_DEPARTMENT") || "",
    doctor: doctorName,
    document: {
      documentType: "",
      documentNumber: "",
      issueDate: "",
      endDate: "",
      expDate: "",
      docFileName: "",
      passportNo: "",
      passportIssueDate: "",
      passportExpDate: "",
      passportFile: "",
      passportFileName: "",
      medicalvisaNo: "",
      medicalvisaIssueDate: "",
      medicalvisaEndDate: "",
      medicalvisaFile: "",
      medicalvisaFileName: "",
      aadharFile: "",
    },
  });

  const [form, setForm] = useState(getEmptyForm());

  // Enhanced Yup validation schema with proper error messages
  const validationSchema = Yup.object().shape({
    salutation: Yup.string().required("Salutation is required"),
    name: Yup.string()
      .required("Patient Name is required")
      .min(2, "Patient Name must be at least 2 characters")
      .matches(
        /^[a-zA-Z\s]+$/,
        "Patient Name should contain only letters and spaces",
      ),
    religion: Yup.string().required("Religion is required"),
    caste: Yup.string().required("Caste is required"),
    nationality: Yup.string().required("Nationality is required"),
    phone: Yup.string()
      .required("Phone number is required")
      .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits"),
    dob: Yup.string().required("Date of Birth is required"),
    // .test(
    //   "age-validation",
    //   "Patient must be at least 1 year old",
    //   function (value) {
    //     if (!value) return false;
    //     const birthDate = new Date(value);
    //     const today = new Date();
    //     const age = today.getFullYear() - birthDate.getFullYear();
    //     return age >= 1;
    //   }
    // ),
    gender: Yup.string()
      .required("Gender is required")
      .notOneOf(["Select", ""], "Please select a valid gender"),
    email: Yup.string().email("Invalid email format"),
    presentAddress: Yup.object().shape({
      address: Yup.string()
        .required("Present address is required")
        .min(0, "Address must be at least 5 characters"),
      policeStation: Yup.string().required("Police station is required"),
      cityDistrict: Yup.string().required("City/District is required"),
      country: Yup.string().required("Present country is required"),
      state: Yup.string().required("Present state is required"),
      pinCode: Yup.string()
        .required("Pin code is required")
        .matches(/^[0-9]{6}$/, "Pin code must be exactly 6 digits"),
    }),
    permanentAddress: Yup.object().shape({
      address: Yup.string().required("Permanent address is required"),
      policeStation: Yup.string().required("Police station is required"),
      cityDistrict: Yup.string().required("City/District is required"),
      country: Yup.string().required("Permanent country is required"),
      state: Yup.string().required("Permanent state is required"),
      pinCode: Yup.string()
        .required("Pin code is required")
        .matches(/^[0-9]{6}$/, "Pin code must be exactly 6 digits"),
    }),
    relatives: Yup.array()
      .of(
        Yup.object()
          .shape({
            salutation: Yup.string(),
            name: Yup.string().trim(),
            relation: Yup.string().trim(),
            phone: Yup.string().trim(),
          })
          .test(
            "all-or-none",
            "If filling a relative, complete all fields",
            function (value) {
              const { salutation, name, relation, phone } = value || {};
              const anyFilled = !!(salutation || name || relation || phone);
              const allFilled =
                !!salutation &&
                !!name &&
                !!relation &&
                !!phone &&
                /^[0-9]{10,12}$/.test(phone) &&
                name.length >= 2;

              if (anyFilled && !allFilled) {
                return this.createError({
                  message:
                    "All fields must be filled for a relative, phone must be 10 to 12 digits, and name must be at least 2 characters.",
                });
              }
              return true;
            },
          ),
      )
      .test(
        "at-least-one-filled",
        "At least one relative must be filled with all fields (salutation, name, relation, phone).",
        (relatives) =>
          Array.isArray(relatives) &&
          relatives.some(
            (rel) =>
              rel &&
              rel.salutation &&
              rel.name &&
              rel.relation &&
              rel.phone &&
              /^[0-9]{10,12}$/.test(rel.phone) &&
              rel.name.length >= 2,
          ),
      ),
    bookingDate: Yup.string().required("Booking date is required"),
    department: Yup.string().required("Department is required"),
    doctor: Yup.string().required("Doctor name is required"),
    document: Yup.object().when("nationality", {
      is: "R_1_2", // Indian nationality
      then: () =>
        Yup.object().shape({
          documentNumber: Yup.string()
            .required("Aadhaar number is required")
            .matches(/^[0-9]{12}$/, "Aadhaar number must be exactly 12 digits"),
        }),
      otherwise: () =>
        Yup.object().shape({
          passportNo: Yup.string()
            .required("Passport number is required")
            .matches(
              /^[A-Za-z0-9]{8}$/,
              "Passport number must be exactly 8 alphanumeric characters",
            ),
          passportIssueDate: Yup.string().required(
            "Passport issue date is required",
          ),
          passportExpDate: Yup.string().required(
            "Passport expiry date is required",
          ),
          medicalvisaNo: Yup.string()
            .required("Medical visa number is required")
            .matches(
              /^[A-Za-z0-9]{8}$/,
              "Medical visa number must be exactly 8 alphanumeric characters",
            ),
          medicalvisaIssueDate: Yup.string().required(
            "Medical visa issue date is required",
          ),
          medicalvisaEndDate: Yup.string().required(
            "Medical visa end date is required",
          ),
        }),
    }),
  });

  // Sync booking date
  useEffect(() => {
    const storedDate = sessionStorage.getItem("SELECTED_DATE");
    if (storedDate) {
      setBookingDate(storedDate);
      setForm((prev) => ({ ...prev, bookingDate: storedDate }));
    }
  }, []);

  useEffect(() => {
    setForm((prev) => ({ ...prev, bookingDate }));
  }, [bookingDate]);

  useEffect(() => {
    if (form?.document?.aadharFile) setFileSelected(true);
  }, [form?.document?.aadharFile]);
  useEffect(() => {
    if (helpers.State && form.presentAddress.country) {
      const filteredStates = helpers.State.filter(
        (s) => s.PARENT_RECORD_ID === form.presentAddress.country,
      ).map((s) => ({ value: s.RECORD_ID, label: s.RECORD_NAME }));
      setStateOptions(filteredStates);
    } else {
      setStateOptions([]);
    }
  }, [form.presentAddress.country, helpers.State]);

  useEffect(() => {
    if (helpers.City && form.presentAddress.state) {
      const filteredCities = helpers.City.filter(
        (c) => c.PARENT_RECORD_ID === form.presentAddress.state,
      ).map((c) => ({ value: c.RECORD_ID, label: c.RECORD_NAME }));
      setCityOptions(filteredCities);
    } else {
      setCityOptions([]);
    }

    // Clear city when state changes
    if (form.presentAddress.city) {
      setForm((prev) => ({
        ...prev,
        presentAddress: { ...prev.presentAddress, city: "" },
      }));
    }
  }, [form.presentAddress.state, helpers.City]);

  // Permanent Address State and City dropdowns
  useEffect(() => {
    if (helpers.State && form.permanentAddress.country && !form.sameAsPresent) {
      const filteredStates = helpers.State.filter(
        (s) => s.PARENT_RECORD_ID === form.permanentAddress.country,
      ).map((s) => ({ value: s.RECORD_ID, label: s.RECORD_NAME }));
      setPermanentStateOptions(filteredStates);
    } else {
      setPermanentStateOptions([]);
    }
  }, [form.permanentAddress.country, helpers.State, form.sameAsPresent]);

  useEffect(() => {
    if (helpers.City && form.permanentAddress.state && !form.sameAsPresent) {
      const filteredCities = helpers.City.filter(
        (c) => c.PARENT_RECORD_ID === form.permanentAddress.state,
      ).map((c) => ({ value: c.RECORD_ID, label: c.RECORD_NAME }));
      setPermanentCityOptions(filteredCities);
    } else {
      setPermanentCityOptions([]);
    }

    // Clear city when state changes
    if (form.permanentAddress.city && !form.sameAsPresent) {
      setForm((prev) => ({
        ...prev,
        permanentAddress: { ...prev.permanentAddress, city: "" },
      }));
    }
  }, [form.permanentAddress.state, helpers.City, form.sameAsPresent]);

  // Handle "Same as Present Address" functionality
  useEffect(() => {
    if (form.sameAsPresent) {
      setForm((prev) => ({
        ...prev,
        permanentAddress: { ...prev.presentAddress },
      }));
      setPermanentStateOptions(stateOptions);
      setPermanentCityOptions(cityOptions);
    }
  }, [form.sameAsPresent, form.presentAddress, stateOptions, cityOptions]);

  const salutationOptions = helpers.TITLES
    ? helpers.TITLES.map((s) => s.RECORD_NAME)
    : ["Select", "Mr.", "Mrs.", "Ms.", "Dr."];

  const nationalityOptions = helpers.nationality
    ? helpers.nationality.map((n) => ({
        code: n.RECORD_ID,
        name: n.RECORD_NAME,
      }))
    : [
        { code: "R_1_2", name: "Indian" },
        { code: "OTHER", name: "Other" },
      ];

  const genderOptions = [
    { label: "Select", value: "" },
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
    { label: "Other", value: "Other" },
  ];

  const relationOptions = helpers.relative
    ? helpers.relative.map((rel) => ({
        value: rel.RECORD_ID,
        label: rel.RECORD_NAME,
      }))
    : [];

  // Helper for field disabling
  const isDisabled = mode !== "edit" || isSubmitting;
  const fieldDisabled = (field) => isDisabled || disabledFields[field];
  const nestedFieldDisabled = (parent, child) =>
    isDisabled || (disabledFields[parent] && disabledFields[parent][child]);

  function handleChange(e) {
    const { name, value } = e.target;
    if (mode === "edit" && disabledFields[name]) return;

    let newValue = value;

    // Prevent numbers in the "name" field
    if (name === "name") {
      newValue = value.replace(/[0-9]/g, "");
    }

    // Update the form state
    setForm((prev) => ({
      ...prev,
      [name]: newValue,
    }));

    // Clear validation errors for the field
    if (mode === "edit" && formErrors[name]) {
      setFormErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  }

  function handlePresentAddressChange(e) {
    if (mode !== "edit") return;

    const { name, value } = e.target;

    if (disabledFields.presentAddress?.[name]) return;

    // Clear error
    if (formErrors.presentAddress?.[name]) {
      setFormErrors((prev) => ({
        ...prev,
        presentAddress: {
          ...prev.presentAddress,
          [name]: "",
        },
      }));
    }

    // Update form
    setForm((prev) => {
      const updatedPresent = {
        ...prev.presentAddress,
        [name]: value,
      };

      // Clear dependent fields when parent changes
      if (name === "country") {
        updatedPresent.state = "";
        updatedPresent.city = "";
      } else if (name === "state") {
        updatedPresent.city = "";
      }

      const newForm = {
        ...prev,
        presentAddress: updatedPresent,
      };

      // Update permanent address if same as present
      if (prev.sameAsPresent) {
        newForm.permanentAddress = { ...updatedPresent };
      }

      return newForm;
    });
  }

  function handlePermanentAddressChange(e) {
    if (mode !== "edit" || form.sameAsPresent) return;

    const { name, value } = e.target;

    if (disabledFields.permanentAddress?.[name]) return;

    // Clear error
    if (formErrors.permanentAddress?.[name]) {
      setFormErrors((prev) => ({
        ...prev,
        permanentAddress: {
          ...prev.permanentAddress,
          [name]: "",
        },
      }));
    }

    setForm((prev) => {
      const updatedPermanent = {
        ...prev.permanentAddress,
        [name]: value,
      };

      // Clear dependent fields when parent changes
      if (name === "country") {
        updatedPermanent.state = "";
        updatedPermanent.city = "";
      } else if (name === "state") {
        updatedPermanent.city = "";
      }

      return {
        ...prev,
        permanentAddress: updatedPermanent,
      };
    });
  }

  function handleSameAsPresent(e) {
    if (mode !== "edit") return;

    const checked = e.target.checked;

    setForm((prev) => ({
      ...prev,
      sameAsPresent: checked,
      permanentAddress: checked
        ? { ...prev.presentAddress }
        : {
            country: "",
            state: "",
            cityDistrict: "",
            city: "",
            address: "",
            policeStation: "",
            pinCode: "",
          },
    }));
  }

  function handleRelativeChange(idx, e) {
    if (mode !== "edit") return;
    const { name, value } = e.target;

    // If this field is disabled, do nothing
    // if (
    //   disabledFields.relatives &&
    //   disabledFields.relatives[idx] &&
    //   disabledFields.relatives[idx][name]
    // )
    //   return;

    // Remove digits only if the field is 'name'
    const sanitizedValue =
      name === "name" ? value.replace(/[0-9]/g, "") : value;

    // Clear specific relative field errors
    if (
      formErrors.relatives &&
      formErrors.relatives[idx] &&
      formErrors.relatives[idx][name]
    ) {
      setFormErrors((prev) => ({
        ...prev,
        relatives: prev.relatives.map((rel, index) =>
          index === idx ? { ...rel, [name]: "" } : rel,
        ),
      }));
    }

    setForm((prev) => {
      const relatives = [...prev.relatives];
      if (!relatives[idx])
        relatives[idx] = { salutation: "", name: "", relation: "", phone: "" };
      relatives[idx][name] = sanitizedValue;
      return { ...prev, relatives };
    });
  }

  function handleBookingChange(e) {
    if (mode !== "edit") return;
    const { name, value } = e.target;
    if (disabledFields[name]) return;

    if (name === "bookingDate") {
      setBookingDate(value);
    } else {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  }

  function handleFileInputChange(type, docKey, value) {
    if (mode !== "edit") return;
    setForm((prev) => ({
      ...prev,
      document: {
        ...prev.document,
        [docKey]: value,
      },
    }));
  }
  // Fetch helpers and initial patient data
  useEffect(() => {
    async function fetchPatientData(uhid) {
      try {
        const tokeng = generateOneTimeToken();
        const res = await axios.post(
          `${config.API_BASE_URL}/GetDataSearchByUHID`,
          {
            TYPE: selectHospital,
            UHID: sessionStorage.getItem("selectedUHID"),
          },
          {
            headers: {
              "Content-Type": "application/json",
              "X-API-Key": tokeng,
            },
          },
        );

        const patient = res?.data?.data?.pDetail?.[0];
        if (!patient) return;

        const localAddr = patient.localAddress?.[0] || {};
        const permaAddr = patient.permaAddress?.[0] || {};

        // Document mapping
        const convertToISO = (dateStr) => {
          if (!dateStr || !dateStr.includes("-")) return "";
          const [dd, mm, yyyy] = dateStr.split("-");
          return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
        };

        const documentDetails = patient.documentDetails || [];
        const document = {};
        for (const doc of documentDetails) {
          let docKey = "";
          let fileKey = "";

          // debugger;
          // const previewUrl =  "";

          if (doc.documentType === "R_11_1") {
            docKey = "aadhar";
            fileKey = `${docKey}File`;

            document.documentType = doc.documentType;
            document.documentNumber = doc.documentNumber || "";
            document.issueDate = doc.issueDate || "";
            document.endDate = doc.endDate || "";
            document.expDate = doc.expDate || "";
            document.docFileName = doc.docFileName || "";
            document.aadharname = doc.docFileName || "";
            document.aadharpreviewUrl =  "";
            // if (previewUrl) {
            setForm((prevForm) => ({
              ...prevForm,
              document: {
                ...prevForm.document,
                [`${fileKey}`]: {
                  name: doc.docFileName || "",
                  base64: "",
                  previewUrl: doc.docFileURL,
                  type: "image/jpeg",
                },
              },
            }));
            setUploadedDocs((prev) => ({
              ...prev,
              [docKey]: true,
            }));
            // }
          }

          else if (doc.documentType === "R_11_4") {
            docKey = "passport";
            fileKey = `${docKey}File`;

            document.passportNo = doc.documentNumber || "";
            document.passportIssueDate = convertToISO(doc.issueDate);
            document.passportExpDate = convertToISO(doc.expDate);
            document.passportFile = doc.docFileName || "";
            document.passportname = doc.docFileName || "";
            document.passportpreviewUrl =  "";
            // if (previewUrl) {
            setForm((prevForm) => ({
              ...prevForm,
              document: {
                ...prevForm.document,
                [`${fileKey}`]: {
                  name: doc.docFileName || "",
                  base64: "",
                  previewUrl: doc.docFileURL,
                  type: "image/jpeg",
                },
              },
            }));
            setUploadedDocs((prev) => ({
              ...prev,
              [docKey]: true,
            }));
            // }
          }

          else if (doc.documentType === "R_11_7") {
            docKey = "medicalvisa";
            fileKey = `${docKey}File`;

            document.medicalvisaNo = doc.documentNumber || "";
            document.medicalvisaIssueDate = convertToISO(doc.issueDate);
            document.medicalvisaEndDate = convertToISO(doc.endDate);
            document.medicalvisaFile = doc.docFileName || "";
            document.medicalvisaname = doc.docFileName || "";
            document.medicalvisapreviewUrl =  "";
            // if (previewUrl) {
            setForm((prevForm) => ({
              ...prevForm,
              document: {
                ...prevForm.document,
                [`${fileKey}`]: {
                  name: doc.docFileName || "",
                  base64: "",
                  previewUrl: doc.docFileURL,
                  type: "image/jpeg", 
                },
              },
            }));

            setUploadedDocs((prev) => ({
              ...prev,
              [docKey]: true,
            }));
            // }
          }

          else {
            continue;
          }

        }

        // Relatives formatting
        const relativesFromAPI = (patient.relation || []).map((rel) => ({
          salutation: rel.salutation || "",
          name: rel.relativeName || "",
          relation: rel.relationID || "",
          phone: rel.relContactNo || "",
        }));

        while (relativesFromAPI.length < 2) {
          relativesFromAPI.push({
            salutation: "",
            name: "",
            relation: "",
            phone: "",
          });
        }

        const formFromApi = {
          salutation: patient.salutation || "",
          name: patient.ptName || "",
          gender: patient.gender || "",
          dob: patient.dob
            ? (() => {
                const parts = patient.dob.split("-");
                return parts.length === 3
                  ? `${parts[2]}-${parts[1].padStart(
                      2,
                      "0",
                    )}-${parts[0].padStart(2, "0")}`
                  : "";
              })()
            : "",
          uhid: patient.uhid || "",
          phone: patient.contactNo || "",
          nationality: patient.nationality || "",
          caste: patient.caste || "",
          religion: patient.religion || "",
          occupation: patient.occupation || "",
          email: patient.email || "",
          monthlyIncome: patient.MONTHLY_INCOME || "",
          presentAddress: {
            address: localAddr.address || "",
            policeStation: localAddr.ps || "",
            city: localAddr.cityDistrict || "",
            cityDistrict: localAddr.cityDistrict || "",
            state: localAddr.state_code || "",
            country: localAddr.country_code || "",
            pinCode: localAddr.pincode || "",
          },
          permanentAddress: {
            address: permaAddr.address || "",
            policeStation: permaAddr.ps || "",
            city: permaAddr.cityDistrict || "",
            cityDistrict: permaAddr.cityDistrict || "",
            state: permaAddr.state_code || "",
            country: permaAddr.country_code || "",
            pinCode: permaAddr.pincode || "",
          },
          relatives: relativesFromAPI,
          document,
        };

        setForm((prev) => ({ ...prev, ...formFromApi }));

        const newDisabledFields = {};
        for (const key of Object.keys(formFromApi)) {
          const value = formFromApi[key];
          if (typeof value === "string" || typeof value === "number") {
            if (value) newDisabledFields[key] = true;
          } else if (Array.isArray(value)) {
            newDisabledFields[key] = value.map((item) => {
              const nestedDisabled = {};
              for (const subKey in item) {
                if (item[subKey]) nestedDisabled[subKey] = true;
              }
              return nestedDisabled;
            });
          } else if (typeof value === "object" && value !== null) {
            newDisabledFields[key] = {};
            for (const subKey in value) {
              if (value[subKey]) newDisabledFields[key][subKey] = true;
            }
          }
        }
        setDisabledFields(newDisabledFields);
      } catch (err) {
        console.error("Error fetching patient data:", err);
      }
    }

    async function fetchHelpersAndMaybePatient() {
      try {
        const tokeng = generateOneTimeToken();
        const res = await axios.post(
          `${config.API_BASE_URL}/PAGE_LOAD_OPD_REGISTRATION_ONLINE`,
          {
            TYPE: selectHospital,
            UHID: sessionStorage.getItem("selectedUHID") || " ",
          },
          {
            headers: {
              "Content-Type": "application/json",
              "X-API-Key": tokeng,
            },
          },
        );

        const apiData = res?.data?.data || {};
        setHelpers(apiData);
        setCountryOptions(
          (apiData.Country || []).map((item) => ({
            value: item.RECORD_ID,
            label: item.RECORD_NAME,
          })),
        );

        if (Array.isArray(apiData.payment) && apiData.payment.length > 0) {
          const paymentInfo = apiData.payment[0];
          sessionStorage.setItem("paymentData", JSON.stringify(paymentInfo));
          setPayment(paymentInfo);
        }

        const stored = sessionStorage.getItem("selectedPatient");
        if (stored) {
          if (stored === "new") {
            setForm(getEmptyForm());
            setDisabledFields({});
          } else {
            let selectedPatient;
            try {
              selectedPatient = JSON.parse(stored);
            } catch {
              selectedPatient = { divclick: stored };
            }
            if (selectedPatient?.divclick) {
              await fetchPatientData(selectedPatient.divclick);
            }
          }
        }
      } catch (err) {
        setError("Could not load form options");
      } finally {
        setLoading(false);
      }
    }

    fetchHelpersAndMaybePatient();
  }, [hospitalName, selectHospital]);

  function handleDocumentUpload(docKey, file) {
    if (!file) return;

    const maxSize = 400 * 1024; // 400 KB limit
    if (file.size > maxSize) {
      alert("File size must be less than or equal to 400 KB.");
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const base64Data = reader.result;
      const base64String = base64Data.replace(/^data:.*;base64,/, "");

      setForm((prevForm) => ({
        ...prevForm,
        document: {
          ...prevForm.document,
          [`${docKey}File`]: {
            raw: file,
            name: file.name,
            base64: base64String,
            previewUrl: base64Data,
            type: file.type,
          },
        },
      }));

      setUploadedDocs((prev) => ({
        ...prev,
        [docKey]: true,
      }));
    };

    reader.readAsDataURL(file);
  }

 const openPreview = (docKey) => {
  const fileObj = form.document?.[`${docKey}File`];
  if (!fileObj?.previewUrl || !fileObj?.type) return;
  const base64Data = fileObj.previewUrl.split(",")[1];
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: fileObj.type });
  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl, "_blank");
  // Optional: cleanup later
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
};



  const validateForm = async () => {
    try {
      await validationSchema.validate(form, { abortEarly: false });
      setFormErrors({});
      return true;
    } catch (err) {
      const errors = {};
      if (err.inner) {
        err.inner.forEach((e) => {
          if (
            e.path.startsWith("presentAddress.") ||
            e.path.startsWith("permanentAddress.")
          ) {
            const [parent, child] = e.path.split(".");
            errors[parent] = errors[parent] || {};
            errors[parent][child] = e.message;
          } else if (e.path.startsWith("relatives")) {
            errors.relatives = errors.relatives || [];
            const match = e.path.match(/relatives\[(\d+)\]\.(\w+)/);
            if (match) {
              const idx = parseInt(match[1], 10);
              const field = match[2];
              if (!errors.relatives[idx]) errors.relatives[idx] = {};
              errors.relatives[idx][field] = e.message;
            }
            if (e.message && !match) {
              errors.relativesError = e.message;
            }
          } else if (e.path.startsWith("document.")) {
            const field = e.path.split(".")[1];
            errors.document = errors.document || {};
            errors.document[field] = e.message;
          } else {
            errors[e.path] = e.message;
          }
        });
      }
      setFormErrors(errors);

      // Scroll to first error
      const firstErrorElement = document.querySelector(".text-danger");
      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }

      return false;
    }
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setIsSubmitting(true);

    const isValid = await validateForm();
    if (!isValid) {
      setIsSubmitting(false);
      toast.error("Please fix the errors in the form.");
      return;
    }

    try {
      const payload = await mapFormToPayload(
        form,
        helpers,
        hospitalName,
        totalAmount,
      );

      if (capturedImage) {
        payload.file_Base64String = "";
      }
      const tokeng = generateOneTimeToken();
      const response = await axios.post(
        `${config.API_BASE_URL}/InsertOnlineAppointmentRegistrationData`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": tokeng,
          },
        },
      );

      const bookingNo = response?.data?.data?.BOOKING_NO;

      if (!bookingNo) {
        throw new Error("Booking number not found in response");
      }

      // toast.success("Appointment registration successful!", {
      //   position: "top-center",
      //   autoClose: 2000,
      // });
      // navigate('/appointment-status')

      // Automatically open Pay Now modal with booking number
      // openPayNowModal({ id: bookingNo });

      if (bookingNo) {
        // await Swal.fire({
        //   icon: "success",
        //   title: "Success",
        //   text: "Appointment registration successful!",
        //   confirmButtonText: "OK",
        // });

        // navigate("/appointment-status");
        openPayNowModal({ id: bookingNo });
        // window.location.reload();
      } else {
        await Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      console.error("Submission Error:", error);
      if (error.response) {
        toast.error(
          `Server Error: ${error.response.data.message || "Unknown error"}`,
        );
      } else if (error.request) {
        toast.error("Network error. Please check your connection.");
      } else {
        toast.error("Failed to submit appointment. Please try again.");
      }
      setError("Submit failed");
    } finally {
      setIsSubmitting(false);
    }
  }
  const handleProceedToPayment = async () => {
    if (!bookingAmountInfo) {
      toast.error("Booking information is missing.");
      return;
    }
    try {
      setIsPaying(true);
      const orderId = bookingAmountInfo.ORDER_ID;
      const customerId = bookingAmountInfo.BOOKING_NO;
      const totalAmount = Number(bookingAmountInfo.REGISTRATION_AMT);

      // 🔹 Dynamic MultiAccount split (example: 30% + 70%)
      const part1 = Math.round(totalAmount * 0.3);
      const part2 = totalAmount - part1;

      const multiAccountInstructionDtls = `${part1}|INR|GRPT||${part2}|INR|NEFT`;
      const tokeng = generateOneTimeToken();
      const response = await fetch(
        // `${config.API_BASE_URL}/CreatePayment`,
        "https://www.sampark.cnci.ac.in/api/CreatePayment",
        {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-API-Key": tokeng },
          body: JSON.stringify({
            amount: totalAmount,
            orderNo: orderId,
            customerId: customerId,
            MultiAccountInstructionDtls: multiAccountInstructionDtls,
          }),
        },
      );

      const data = await response.json();
      setTimeout(() => {
        submitToSbiEpay(data);
      }, 80);
    } catch (err) {
      console.error(err);
      setIsPaying(false);
      toast.error("Unable to initiate payment");
    }
  };

  const submitToSbiEpay = ({
    encryptTrans,
    encryptMulti,
    merchIdVal,
    actionUrl,
  }) => {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = actionUrl;

    const t = document.createElement("input");
    t.type = "hidden";
    t.name = "EncryptTrans";
    t.value = encryptTrans;

    const m = document.createElement("input");
    m.type = "hidden";
    m.name = "MultiAccountInstructionDtls";
    m.value = encryptMulti;

    const merch = document.createElement("input");
    merch.type = "hidden";
    merch.name = "merchIdVal";
    merch.value = merchIdVal;

    form.appendChild(t);
    form.appendChild(m);
    form.appendChild(merch);

    document.body.appendChild(form);
    form.submit();
  };
  const getAgeParts = (dob) => {
    if (!dob) return { years: 0, months: 0, days: 0 };
    const birthDate = new Date(dob);
    const today = new Date();
    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    if (days < 0) {
      months--;
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += prevMonth.getDate();
    }
    if (months < 0) {
      years--;
      months += 12;
    }
    return { years, months, days };
  };

  const openCamera = async () => {
    setCameraOn(true);
    setCapturedImage(null);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      }
    } catch (error) {
      console.error("Error accessing camera:", error);
      toast.error("Error accessing camera. Please check permissions.");
    }
  };

  const capturePhoto = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;
    if (!canvas || !video) return;

    const context = canvas.getContext("2d");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageDataUrl = canvas.toDataURL("image/png");
    const base64Image = imageDataUrl.split(",")[1];
    setCapturedImage(base64Image);
    stopCamera();
    toast.success("Photo captured successfully!");
  };

  const stopCamera = () => {
    const stream = videoRef.current?.srcObject;
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    setCameraOn(false);
  };

  const handleGotoDashboard = () => {
    navigate("/");
  };

  const loginMobile = sessionStorage.getItem("loginMobile");
  const SELECTED_DATE = sessionStorage.getItem("SELECTED_DATE");
  const SELECTED_DEPARTMENT = sessionStorage.getItem("SELECTED_DEPARTMENT");

  if (!loginMobile) {
    navigate("/login");
    return;
  }

  if (!SELECTED_DATE || !SELECTED_DEPARTMENT || !selectedDoctor?.name) {
    navigate("/");
    return;
  }

  if (loading) {
    return (
      <div className="page">
        <div className="container py-5 text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">
              <PulseLoader />
            </span>
          </div>
        </div>
      </div>
    );
  }

  const openPayNowModal = async (order) => {
    setPayNowLoadingId(order.id);
    try {
      const tokeng = generateOneTimeToken();
      const response = await fetch(
        `${config.API_BASE_URL}/PROC_GET_BOOKING_AMOUNT_ID`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": tokeng,
          },
          body: JSON.stringify({
            BOOKINGID: order.id,
            TYPE: hospitalName === "hazra" ? "hazra" : "newtown",
          }),
        },
      );

      if (!response.ok) throw new Error("Failed to fetch");

      const data = await response.json();

      if (data?.status !== 200 || !data?.data) {
        toast.error("Invalid booking info");
        return;
      }

      setBookingAmountInfo(data.data);
      setSelectedOrder(order);
    } catch (error) {
      console.error("Error fetching booking amount:", error);
      toast.error("Unable to fetch booking amount");
    } finally {
      setPayNowLoadingId(null);
    }
  };

  const totalAmount = (
    parseFloat(payment.reg_rate || 0) +
    (parseFloat(payment.FOLLOWUP || 0) > 0
      ? parseFloat(payment.FOLLOWUP || 0)
      : parseFloat(payment.CONSULT || 0))
  ).toFixed(2);

  return (
    <div className="page">
      <ToastContainer position="top-center" />
      <div className="page-main">
        <Header />
        <form
          onSubmit={handleSubmit}
          className="container py-2"
          autoComplete="off"
          encType="multipart/form-data"
        >
          <div className="row mt-5">
            {/* Booking info */}
            <div className="col-md-12 mb-6">
              <div className="card-header bg-gradient-primary text-white text-center py-3 rounded-top-4 mb-3">
                <h4 className="mb-0 fw-semibold text-white">
                  <i className="fa-solid fa-book"></i>&nbsp; Booking Details
                </h4>
              </div>

              {/* Form Row */}
              <div className="row px-2">
                {/* Patient Category */}
                <div className="col-md-3 mb-3">
                  <label className="label-custom">
                    Patient Category <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm input-custom"
                    value="Private"
                    style={{ cursor: "not-allowed" }}
                    disabled
                  />
                </div>

                {/* Booking Date */}
                <div className="col-md-3 mb-3">
                  <label className="label-custom">
                    Booking Date <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control form-control-sm input-custom ${
                      formErrors.bookingDate ? "is-invalid" : ""
                    }`}
                    name="bookingDate"
                    value={bookingDate}
                    onChange={handleBookingChange}
                    style={{ cursor: "not-allowed" }}
                    disabled
                  />
                  {formErrors.bookingDate && (
                    <div className="text-danger small mt-1">
                      {formErrors.bookingDate}
                    </div>
                  )}
                </div>

                {/* Department */}
                <div className="col-md-3 mb-3">
                  <label className="label-custom">
                    Department <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm input-custom"
                    name="department"
                    value={form.department_name}
                    style={{ cursor: "not-allowed" }}
                    disabled
                  />
                </div>

                {/* Doctor Name */}
                <div className="col-md-3 mb-3">
                  <label className="label-custom">Doctor Name *</label>
                  <input
                    type="text"
                    className="form-control form-control-sm input-custom"
                    name="doctorName"
                    value={form.doctor}
                    style={{ cursor: "not-allowed" }}
                    disabled
                  />
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="card shadow border-0 rounded-4 custom-card">
                <div className="card-header bg-gradient-primary text-white text-center py-3 rounded-top-4">
                  <h4 className="mb-0 fw-semibold text-white">
                    <i className="fa fa-user" aria-hidden="true"></i>&nbsp;
                    Patient Basic Info
                  </h4>
                </div>
                <div className="card-body px-4">
                  <div className="row">
                    <div
                      className="col-md-8"
                      style={{ borderRight: "1px solid #ccc" }}
                    >
                      <div className="row g-3">
                        <div className="col-md-2 mb-3">
                          <label className="label-custom">
                            Salutation <span className="text-danger">* </span>
                          </label>

                          <Select
                            classNamePrefix="react-select"
                            name="salutation"
                            placeholder="Select"
                            options={salutationOptions.map((s) => ({
                              value: s === "Select" ? "" : s,
                              label: s,
                            }))}
                            value={
                              salutationOptions
                                .map((s) => ({
                                  value: s === "Select" ? "" : s,
                                  label: s,
                                }))
                                .find(
                                  (option) => option.value === form.salutation,
                                ) || null
                            }
                            onChange={(selectedOption) => {
                              const selectedValue = selectedOption
                                ? selectedOption.value
                                : "";

                              // Update salutation
                              handleChange({
                                target: {
                                  name: "salutation",
                                  value: selectedValue,
                                },
                              });

                              // Auto-update gender
                              let autoGender = "";
                              if (selectedValue === "Mr.") {
                                autoGender = "Male";
                              } else if (
                                ["Mrs.", "Ms.", "Miss."].includes(selectedValue)
                              ) {
                                autoGender = "Female";
                              }

                              handleChange({
                                target: {
                                  name: "gender",
                                  value: autoGender,
                                },
                              });
                            }}
                            isDisabled={fieldDisabled("salutation")}
                          />

                          {formErrors.salutation && (
                            <div className="text-danger small mt-1">
                              {formErrors.salutation}
                            </div>
                          )}
                        </div>
                        <div className="col-md-4">
                          <label className="label-custom">
                            Patient Name<span className="text-danger">* </span>
                          </label>
                          <input
                            type="text"
                            className={`form-control form-control-sm input-custom ${
                              formErrors.name ? "is-invalid" : ""
                            }`}
                            placeholder="Enter patient name"
                            name="name"
                            value={form.name}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                              const isControlKey =
                                e.key === "Backspace" ||
                                e.key === "Delete" ||
                                e.key === "ArrowLeft" ||
                                e.key === "ArrowRight" ||
                                e.key === "Tab" ||
                                e.key === "Home" ||
                                e.key === "End";

                              const isLetterOrSpace = /^[a-zA-Z\s]$/.test(
                                e.key,
                              );

                              if (!isLetterOrSpace && !isControlKey) {
                                e.preventDefault(); // Block anything that's not a letter, space, or control key
                              }
                            }}
                            disabled={fieldDisabled("name")}
                          />

                          {formErrors.name && (
                            <div className="text-danger small mt-1">
                              {formErrors.name}
                            </div>
                          )}
                        </div>
                        <div className="col-md-3">
                          <label className="label-custom">
                            Religion <span className="text-danger">* </span>
                          </label>
                          <Select
                            classNamePrefix="react-select"
                            name="religion"
                            placeholder="Select Religion"
                            options={(helpers.religion || []).map((r) => ({
                              value: r.RECORD_ID,
                              label: r.RECORD_NAME,
                            }))}
                            value={
                              (helpers.religion || [])
                                .map((r) => ({
                                  value: r.RECORD_ID,
                                  label: r.RECORD_NAME,
                                }))
                                .find(
                                  (option) => option.value === form.religion,
                                ) || null
                            }
                            onChange={(selectedOption) =>
                              handleChange({
                                target: {
                                  name: "religion",
                                  value: selectedOption
                                    ? selectedOption.value
                                    : "",
                                },
                              })
                            }
                            isDisabled={fieldDisabled("religion")}
                          />
                          {formErrors.religion && (
                            <div className="text-danger small mt-1">
                              {formErrors.religion}
                            </div>
                          )}
                        </div>
                        <div className="col-md-3">
                          <label className="label-custom">
                            Caste <span className="text-danger">* </span>
                          </label>
                          <Select
                            classNamePrefix="react-select"
                            name="caste"
                            placeholder="Select Caste"
                            options={(helpers.caste || []).map((c) => ({
                              value: c.RECORD_ID,
                              label: c.RECORD_NAME,
                            }))}
                            value={
                              (helpers.caste || [])
                                .map((c) => ({
                                  value: c.RECORD_ID,
                                  label: c.RECORD_NAME,
                                }))
                                .find(
                                  (option) => option.value === form.caste,
                                ) || null
                            }
                            onChange={(selectedOption) =>
                              handleChange({
                                target: {
                                  name: "caste",
                                  value: selectedOption
                                    ? selectedOption.value
                                    : "",
                                },
                              })
                            }
                            isDisabled={fieldDisabled("caste")}
                          />
                          {formErrors.caste && (
                            <div className="text-danger small mt-1">
                              {formErrors.caste}
                            </div>
                          )}
                        </div>
                        <div className="col-md-3">
                          <label className="label-custom">
                            Nationality <span className="text-danger">* </span>
                          </label>
                          <Select
                            classNamePrefix="react-select"
                            name="nationality"
                            placeholder="Select Nationality"
                            options={nationalityOptions.map((n) => ({
                              value: n.code,
                              label: n.name,
                            }))}
                            value={
                              nationalityOptions
                                .map((n) => ({
                                  value: n.code,
                                  label: n.name,
                                }))
                                .find(
                                  (option) => option.value === form.nationality,
                                ) || null
                            }
                            onChange={(selectedOption) =>
                              handleChange({
                                target: {
                                  name: "nationality",
                                  value: selectedOption
                                    ? selectedOption.value
                                    : "",
                                },
                              })
                            }
                            isDisabled={fieldDisabled("nationality")}
                          />
                          {formErrors.nationality && (
                            <div className="text-danger small mt-1">
                              {formErrors.nationality}
                            </div>
                          )}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="dob" className="label-custom">
                            Date of Birth{" "}
                            <span className="text-danger">* </span>
                          </label>

                          <div className="relative w-full sm:w-full">
                            <DatePicker
                              id="dob"
                              selected={form.dob ? new Date(form.dob) : null}
                              onChange={(date) => {
                                const today = new Date();
                                if (date && date > today) {
                                  date = today;
                                }

                                // Store as ISO format (yyyy-MM-dd)
                                const formattedDate = date
                                  ? `${date.getFullYear()}-${String(
                                      date.getMonth() + 1,
                                    ).padStart(2, "0")}-${String(
                                      date.getDate(),
                                    ).padStart(2, "0")}`
                                  : "";

                                handleChange({
                                  target: { name: "dob", value: formattedDate },
                                });
                              }}
                              maxDate={new Date()}
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              dateFormat="dd-MM-yyyy" // Display format
                              className={`form-control form-control-sm input-custom pr-10 w-full sm:w-auto ${
                                formErrors.dob ? "is-invalid" : ""
                              }`}
                              placeholderText="Select date of birth"
                              disabled={fieldDisabled("dob")}
                            />
                            <FaRegCalendarAlt className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none" />
                          </div>

                          {formErrors.dob && (
                            <div className="text-danger small mt-1">
                              {formErrors.dob}
                            </div>
                          )}
                        </div>
                        {form.dob && (
                          <>
                            <div className="col-md-2">
                              <label className="form-label fw-semibold">
                                Year
                              </label>
                              <input
                                type="text"
                                className="form-control form-control-sm input-custom text-gray-400"
                                value={getAgeParts(form.dob).years}
                                readOnly
                              />
                            </div>
                            <div className="col-md-2">
                              <label className="form-label fw-semibold">
                                Month
                              </label>
                              <input
                                type="text"
                                className="form-control form-control-sm input-custom text-gray-400"
                                value={getAgeParts(form.dob).months}
                                readOnly
                              />
                            </div>
                            <div className="col-md-2">
                              <label className="form-label fw-semibold">
                                Day
                              </label>
                              <input
                                type="text"
                                className="form-control form-control-sm input-custom text-gray-400"
                                value={getAgeParts(form.dob).days}
                                readOnly
                              />
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row g-3">
                        <div className="col-md-6 mb-3">
                          <label className="label-custom">
                            Phone Number <span className="text-danger">* </span>
                          </label>
                          <div className="d-flex gap-2">
                            <input
                              type="text"
                              className="form-control form-control-sm input-custom"
                              name="countryCode"
                              placeholder="e.g., 91"
                              value={form.countryCode}
                              onChange={handleChange}
                              style={{
                                maxWidth: "100px",
                                cursor: "not-allowed",
                              }}
                              disabled
                            />
                            <input
                              type="tel"
                              className={`form-control form-control-sm input-custom ${
                                formErrors.phone ? "is-invalid" : ""
                              }`}
                              placeholder="Enter phone number"
                              name="phone"
                              value={form.phone}
                              disabled
                              onChange={handleChange}
                            />
                          </div>
                          {formErrors.phone && (
                            <div className="text-danger small mt-1">
                              {formErrors.phone}
                            </div>
                          )}
                        </div>
                        <div className="col-md-6">
                          <label className="label-custom">
                            Gender <span className="text-danger">* </span>
                          </label>
                          <Select
                            classNamePrefix="react-select"
                            className={`react-select-container ${
                              formErrors.gender ? "is-invalid" : ""
                            }`}
                            name="gender"
                            value={genderOptions.find(
                              (option) => option.value === form.gender,
                            )}
                            onChange={(selectedOption) => {
                              handleChange({
                                target: {
                                  name: "gender",
                                  value: selectedOption?.value || "",
                                },
                              });
                            }}
                            options={genderOptions}
                            isDisabled={fieldDisabled("gender")}
                          />

                          {formErrors.gender && (
                            <div className="text-danger small mt-1">
                              {formErrors.gender}
                            </div>
                          )}
                        </div>
                        <div className="col-md-6">
                          <label className="label-custom">Email</label>
                          <input
                            type="email"
                            name="email"
                            className={`form-control form-control-sm input-custom ${
                              formErrors.email ? "is-invalid" : ""
                            }`}
                            placeholder="Enter email"
                            autoComplete="off"
                            autoCorrect="off"
                            spellCheck="false"
                            value={form.email}
                            onChange={handleChange}
                            disabled={fieldDisabled("email")}
                          />
                          {formErrors.email && (
                            <div className="text-danger small mt-1">
                              {formErrors.email}
                            </div>
                          )}
                        </div>
                        {/* {form.uhid &&
                          <div className="col-md-6">
                            <label className="label-custom">UHID</label>
                            <input
                              type="text"
                              name="uhid"
                              className="form-control form-control-sm input-custom"
                              placeholder="UHID"
                              value={form.uhid}
                              disabled
                            />
                          </div>
                        } */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Present Address */}
            <div className="col-md-12">
              <div className="card shadow border-0 rounded-4 custom-card">
                <div className="card-header bg-gradient-primary text-white py-3 rounded-top-4 d-flex justify-content-between align-items-center">
                  <h4 className="mb-0 fw-semibold text-white">
                    <i className="fa fa-address-card" aria-hidden="true"></i>{" "}
                    &nbsp; Patient's Address
                  </h4>
                </div>
                <div className="card-body px-4">
                  <div className="row g-3">
                    {/* Country */}
                    <div className="col-md-6 mb-3">
                      <label className="label-custom">
                        Country <span className="text-danger">* </span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        name="country"
                        placeholder="Select Country"
                        options={countryOptions}
                        isDisabled={nestedFieldDisabled(
                          "presentAddress",
                          "country",
                        )}
                        value={countryOptions.find(
                          (option) =>
                            option.value === form?.presentAddress?.country,
                        )}
                        onChange={(selectedOption) =>
                          handlePresentAddressChange({
                            target: {
                              name: "country",
                              value: selectedOption?.value || "",
                            },
                          })
                        }
                      />
                      {formErrors?.presentAddress?.country && (
                        <div className="text-danger small mt-1">
                          {formErrors.presentAddress.country}
                        </div>
                      )}
                    </div>
                    {/* State */}
                    <div className="col-md-6 mb-3">
                      <label className="label-custom">
                        State <span className="text-danger">* </span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        name="state"
                        placeholder="Select State"
                        options={stateOptions}
                        isDisabled={
                          !form?.presentAddress?.country ||
                          nestedFieldDisabled("presentAddress", "state")
                        }
                        value={stateOptions.find(
                          (option) =>
                            option.value === form?.presentAddress?.state,
                        )}
                        onChange={(selectedOption) =>
                          handlePresentAddressChange({
                            target: {
                              name: "state",
                              value: selectedOption ? selectedOption.value : "",
                            },
                          })
                        }
                      />
                      {formErrors?.presentAddress?.state && (
                        <div className="text-danger small mt-1">
                          {formErrors.presentAddress.state}
                        </div>
                      )}
                    </div>
                    {/* City/District */}
                    <div className="col-md-6 mb-3">
                      <label className="label-custom">
                        City/District <span className="text-danger">* </span>
                      </label>
                      <input
                        type="text"
                        className={`form-control form-control-sm input-custom ${
                          formErrors?.presentAddress?.cityDistrict
                            ? "is-invalid"
                            : ""
                        }`}
                        name="cityDistrict"
                        placeholder="Enter City/District"
                        value={form?.presentAddress?.cityDistrict || ""}
                        onChange={handlePresentAddressChange}
                        disabled={nestedFieldDisabled(
                          "presentAddress",
                          "cityDistrict",
                        )}
                      />
                      {formErrors.presentAddress &&
                        formErrors.presentAddress.cityDistrict && (
                          <div className="text-danger small mt-1">
                            {formErrors.presentAddress.cityDistrict}
                          </div>
                        )}
                    </div>
                    {/* Address */}
                    <div className="col-md-6 mb-3">
                      <label className="label-custom">
                        Address <span className="text-danger">* </span>
                      </label>
                      <input
                        type="text"
                        className={`form-control form-control-sm input-custom ${
                          formErrors?.presentAddress?.address
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Enter address"
                        name="address"
                        value={form?.presentAddress?.address || ""}
                        onChange={handlePresentAddressChange}
                        disabled={nestedFieldDisabled(
                          "presentAddress",
                          "address",
                        )}
                      />
                      {formErrors.presentAddress &&
                        formErrors.presentAddress.address && (
                          <div className="text-danger small mt-1">
                            {formErrors.presentAddress.address}
                          </div>
                        )}
                    </div>
                    {/* Police Station */}
                    <div className="col-md-6 mb-3">
                      <label className="label-custom">
                        Police Station <span className="text-danger">* </span>
                      </label>
                      <input
                        type="text"
                        className={`form-control form-control-sm input-custom ${
                          formErrors?.presentAddress?.policeStation
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Enter police station"
                        name="policeStation"
                        value={form?.presentAddress?.policeStation || ""}
                        onChange={handlePresentAddressChange}
                        disabled={nestedFieldDisabled(
                          "presentAddress",
                          "policeStation",
                        )}
                      />
                      {formErrors.presentAddress &&
                        formErrors.presentAddress.policeStation && (
                          <div className="text-danger small mt-1">
                            {formErrors.presentAddress.policeStation}
                          </div>
                        )}
                    </div>
                    {/* Pin Code */}
                    <div className="col-md-6 mb-3">
                      <label className="label-custom">
                        Pin Code <span className="text-danger">* </span>
                      </label>
                      <input
                        type="text"
                        className={`form-control form-control-sm input-custom ${
                          formErrors?.presentAddress?.pinCode
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Enter pin code"
                        name="pinCode"
                        value={form?.presentAddress?.pinCode || ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,6}$/.test(value)) {
                            handlePresentAddressChange(e);
                          }
                        }}
                        maxLength={6}
                        inputMode="numeric"
                        pattern="\d{6}"
                        disabled={nestedFieldDisabled(
                          "presentAddress",
                          "pinCode",
                        )}
                      />
                      {formErrors.presentAddress &&
                        formErrors.presentAddress.pinCode && (
                          <div className="text-danger small mt-1">
                            {formErrors.presentAddress.pinCode}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Permanent Address */}
            <div className="col-md-6" style={{ display: "none" }}>
              <div className="card shadow border-0 rounded-4 custom-card">
                <div className="card-header bg-gradient-primary text-white py-3 rounded-top-4 d-flex justify-content-between align-items-center">
                  <h4 className="mb-0 fw-semibold text-white">
                    <i className="fa fa-address-card" aria-hidden="true"></i>
                    &nbsp; Permanent Address
                  </h4>
                  <label
                    className="d-flex align-items-center mb-0"
                    style={{ cursor: "pointer", display: "none" }} // 🔹 Checkbox hidden
                  >
                    <input
                      type="checkbox"
                      className="form-check-input"
                      // checked={true} // 🔹 Always checked
                      onChange={handleSameAsPresent}
                      style={{ transform: "scale(1.2)" }}
                      disabled={isDisabled}
                      checked={form?.sameAsPresent}
                    />
                    <span
                      className="fw-medium"
                      style={{
                        userSelect: "none",
                        fontSize: "0.85rem",
                        marginRight: "-1.3rem",
                      }}
                    >
                      ( Same as Present Address )
                    </span>
                  </label>
                </div>
                <div className="card-body px-4">
                  <div className="row g-3">
                    {/* Country */}
                    <div className="col-md-6 mb-3">
                      <label className="label-custom">
                        Country <span className="text-danger">* </span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        name="country"
                        placeholder="Select Country"
                        isDisabled={form?.sameAsPresent || isDisabled}
                        options={countryOptions}
                        value={countryOptions.find(
                          (option) =>
                            option.value === form?.permanentAddress?.country,
                        )}
                        onChange={(selectedOption) =>
                          handlePermanentAddressChange({
                            target: {
                              name: "country",
                              value: selectedOption?.value || "",
                            },
                          })
                        }
                      />
                      {formErrors.permanentAddress &&
                        formErrors.permanentAddress.country && (
                          <div className="text-danger small mt-1">
                            {formErrors.permanentAddress.country}
                          </div>
                        )}
                    </div>
                    {/* State */}
                    <div className="col-md-6 mb-3">
                      <label className="label-custom">
                        State <span className="text-danger">* </span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        name="state"
                        placeholder="Select State"
                        isDisabled={form?.sameAsPresent || isDisabled}
                        options={
                          form?.sameAsPresent
                            ? stateOptions
                            : permanentStateOptions
                        }
                        value={(form?.sameAsPresent
                          ? stateOptions
                          : permanentStateOptions
                        ).find(
                          (option) =>
                            option.value === form?.permanentAddress?.state,
                        )}
                        onChange={(selectedOption) =>
                          handlePermanentAddressChange({
                            target: {
                              name: "state",
                              value: selectedOption?.value || "",
                            },
                          })
                        }
                      />
                      {formErrors.permanentAddress &&
                        formErrors.permanentAddress.state && (
                          <div className="text-danger small mt-1">
                            {formErrors.permanentAddress.state}
                          </div>
                        )}
                    </div>
                    {/* City/District */}
                    <div className="col-md-6 mb-3">
                      <label className="label-custom">
                        City/District <span className="text-danger">* </span>
                      </label>
                      <input
                        type="text"
                        className={`form-control form-control-sm input-custom ${
                          formErrors?.permanentAddress?.cityDistrict
                            ? "is-invalid"
                            : ""
                        }`}
                        name="cityDistrict"
                        placeholder="Enter City/District"
                        value={form?.permanentAddress?.cityDistrict || ""}
                        onChange={handlePermanentAddressChange}
                        disabled={
                          form?.sameAsPresent ||
                          nestedFieldDisabled(
                            "permanentAddress",
                            "cityDistrict",
                          )
                        }
                      />
                      {formErrors.permanentAddress &&
                        formErrors.permanentAddress.cityDistrict && (
                          <div className="text-danger small mt-1">
                            {formErrors.permanentAddress.cityDistrict}
                          </div>
                        )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="label-custom">
                        Address <span className="text-danger">* </span>
                      </label>
                      <input
                        type="text"
                        className={`form-control form-control-sm input-custom ${
                          formErrors?.permanentAddress?.address
                            ? "is-invalid "
                            : ""
                        }`}
                        placeholder="Enter address"
                        name="address"
                        value={form?.permanentAddress?.address || ""}
                        onChange={handlePermanentAddressChange}
                        disabled={
                          form?.sameAsPresent ||
                          nestedFieldDisabled("permanentAddress", "address")
                        }
                      />
                      {formErrors.permanentAddress &&
                        formErrors.permanentAddress.address && (
                          <div className="text-danger small mt-1">
                            {formErrors.permanentAddress.address}
                          </div>
                        )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="label-custom">
                        Police Station <span className="text-danger">* </span>
                      </label>
                      <input
                        type="text"
                        className={`form-control form-control-sm input-custom ${
                          formErrors?.permanentAddress?.policeStation
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Enter police station"
                        name="policeStation"
                        value={form?.permanentAddress?.policeStation || ""}
                        onChange={handlePermanentAddressChange}
                        disabled={
                          form?.sameAsPresent ||
                          nestedFieldDisabled(
                            "permanentAddress",
                            "policeStation",
                          )
                        }
                      />
                      {formErrors.permanentAddress &&
                        formErrors.permanentAddress.policeStation && (
                          <div className="text-danger small mt-1">
                            {formErrors.permanentAddress.policeStation}
                          </div>
                        )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="label-custom">
                        Pin Code <span className="text-danger">* </span>
                      </label>
                      <input
                        type="text"
                        className={`form-control form-control-sm input-custom ${
                          formErrors?.permanentAddress?.pinCode
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Enter pin code"
                        name="pinCode"
                        value={form?.permanentAddress?.pinCode || ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,6}$/.test(value)) {
                            handlePermanentAddressChange(e);
                          }
                        }}
                        maxLength={6}
                        disabled={
                          form?.sameAsPresent ||
                          nestedFieldDisabled("permanentAddress", "pinCode")
                        }
                      />
                      {formErrors.permanentAddress &&
                        formErrors.permanentAddress.pinCode && (
                          <div className="text-danger small mt-1">
                            {formErrors.permanentAddress.pinCode}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Documents Table */}
            <div className="col-md-6">
              <div className="card shadow border-0 rounded-4 custom-card">
                <div
                  className="card-header bg-gradient-primary text-white text-center py-3 rounded-top-4"
                  style={{ borderBottom: "none" }}
                >
                  <h4 className="mb-0 fw-semibold text-white">
                    <i className="fa fa-file text me-2 "></i> Documents
                  </h4>
                </div>
                <div className="card-body px-2 py-2 bg-light overflow-x-auto">
                  <div className="">
                    <table className="table table-bordered table-hover align-middle text-center shadow-sm rounded-3 overflow-hidden">
                      <thead className="bg-gray-200 text-xs">
                        <tr>
                          <th>
                            Document Type<span className="text-red-500">*</span>
                          </th>
                          <th>Document No.</th>
                          <th>Issue Date</th>
                          <th>End Date</th>
                          <th>Exp. Date</th>
                          <th>Document Upload</th>
                        </tr>
                      </thead>

                      {/* If no nationality selected, show only message */}
                      {!form.nationality ? (
                        <tbody>
                          <tr>
                            <td
                              colSpan={6}
                              className="text-center text-gray-500 py-4 italic"
                            >
                              Please select your nationality to continue.
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody className="divide-y divide-gray-200 bg-white text-sm">
                          {/* Aadhaar Card for Indian Nationals */}
                          {form.nationality === "R_1_2" && (
                            <tr className="align-middle hover:bg-gray-50">
                              <td className="font-medium text-blue-700 whitespace-nowrap">
                                Aadhaar Card
                              </td>
                              <td>
                                <input
                                  type="text"
                                  name="documentNumber"
                                  maxLength={12}
                                  pattern="\d{12}"
                                  className={`w-full px-3 py-2 border text-sm rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none ${
                                    formErrors?.document?.documentNumber
                                      ? "border-red-500"
                                      : "border-gray-300"
                                  }`}
                                  placeholder="Enter Aadhaar Number"
                                  value={form.document?.documentNumber || ""}
                                  onChange={(e) =>
                                    handleFileInputChange(
                                      "text",
                                      "documentNumber",
                                      e.target.value,
                                    )
                                  }
                                  disabled={isDisabled}
                                />
                                {formErrors?.document?.documentNumber && (
                                  <div className="text-red-600 text-xs mt-1">
                                    {formErrors.document.documentNumber}
                                  </div>
                                )}
                              </td>
                              <td colSpan={3}></td>
                              <td className="text-center">
                                <label className="cursor-pointer inline-flex items-center px-2 py-2 mb-0 bg-blue-600 text-white rounded-md shadow hover:bg-blue-700 transition duration-200">
                                  {!uploadedDocs["aadhar"]
                                    ? "Upload File"
                                    : "Edit"}
                                  <input
                                    type="file"
                                    className="hidden"
                                    accept=".jpg,.jpeg,.png,.pdf"
                                    onChange={(e) => {
                                      const file = e.target.files[0];
                                      handleDocumentUpload("aadhar", file);
                                    }}
                                  />
                                </label>
                                {uploadedDocs["aadhar"] && (
                                  <>
                                    <span className="text-green-600 text-sm font-medium flex items-center">
                                      <svg
                                        className="w-4 h-4 mr-1"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M5 13l4 4L19 7"
                                        />
                                      </svg>
                                      Uploaded
                                    </span>
                                    {form.document?.aadharFile?.previewUrl && (
                                      <button
                                        type="button"
                                        className="text-blue-600 text-sm underline hover:text-blue-800"
                                        onClick={() => openPreview("aadhar")}
                                      >
                                        <FaEye />
                                      </button>
                                    )}
                                  </>
                                )}
                              </td>
                            </tr>
                          )}

                          {/* Passport & Medical Visa for others */}
                          {form.nationality !== "R_1_2" &&
                            ["Passport", "Medical Visa"].map((doc) => {
                              const docKey = doc.toLowerCase().replace(" ", ""); // passport / medicalvisa
                              const isMedicalVisa = doc === "Medical Visa";

                              return (
                                <tr
                                  className="align-middle hover:bg-gray-50"
                                  key={doc}
                                >
                                  <td className="font-medium text-blue-700 whitespace-nowrap">
                                    {doc}
                                  </td>

                                  {/* Document No. */}
                                  <td>
                                    <input
                                      type="text"
                                      name={`${docKey}No`}
                                      maxLength={8}
                                      pattern="[A-Za-z0-9]{8}"
                                      className={`w-full px-3 py-2 border text-sm rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none ${
                                        formErrors?.document?.[`${docKey}No`]
                                          ? "border-red-500"
                                          : "border-gray-300"
                                      }`}
                                      placeholder={`Enter ${doc} No.`}
                                      value={
                                        form?.document?.[`${docKey}No`] || ""
                                      }
                                      onChange={(e) => {
                                        const value =
                                          e.target.value.toUpperCase();
                                        if (/^[A-Za-z0-9]{0,8}$/.test(value)) {
                                          handleFileInputChange(
                                            "text",
                                            `${docKey}No`,
                                            value,
                                          );
                                        }
                                      }}
                                      disabled={isDisabled}
                                    />
                                    {formErrors?.document?.[`${docKey}No`] && (
                                      <div className="text-red-600 text-xs mt-1">
                                        {formErrors.document[`${docKey}No`]}
                                      </div>
                                    )}
                                  </td>

                                  {/* Issue Date */}
                                  <td>
                                    <input
                                      type="date"
                                      name={`${docKey}IssueDate`}
                                      className={`w-full px-3 py-2 border text-sm rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none ${
                                        formErrors?.document?.[
                                          `${docKey}IssueDate`
                                        ]
                                          ? "border-red-500"
                                          : "border-gray-300"
                                      }`}
                                      value={
                                        form.document?.[`${docKey}IssueDate`] ||
                                        ""
                                      }
                                      onChange={(e) =>
                                        handleFileInputChange(
                                          "date",
                                          `${docKey}IssueDate`,
                                          e.target.value,
                                        )
                                      }
                                      disabled={isDisabled}
                                    />
                                    {formErrors?.document?.[
                                      `${docKey}IssueDate`
                                    ] && (
                                      <div className="text-red-600 text-xs mt-1">
                                        {
                                          formErrors.document[
                                            `${docKey}IssueDate`
                                          ]
                                        }
                                      </div>
                                    )}
                                  </td>

                                  {/* End Date (Medical Visa only) */}
                                  <td>
                                    {isMedicalVisa && (
                                      <>
                                        <input
                                          type="date"
                                          name={`${docKey}EndDate`}
                                          className={`w-full px-3 py-2 border text-sm rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none ${
                                            formErrors?.document?.[
                                              `${docKey}EndDate`
                                            ]
                                              ? "border-red-500"
                                              : "border-gray-300"
                                          }`}
                                          value={
                                            form.document?.[
                                              `${docKey}EndDate`
                                            ] || ""
                                          }
                                          onChange={(e) =>
                                            handleFileInputChange(
                                              "date",
                                              `${docKey}EndDate`,
                                              e.target.value,
                                            )
                                          }
                                          disabled={isDisabled}
                                        />
                                        {formErrors?.document?.[
                                          `${docKey}EndDate`
                                        ] && (
                                          <div className="text-red-600 text-xs mt-1">
                                            {
                                              formErrors.document[
                                                `${docKey}EndDate`
                                              ]
                                            }
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </td>

                                  {/* Expiry Date (Not for Medical Visa) */}
                                  <td>
                                    {!isMedicalVisa && (
                                      <>
                                        <input
                                          type="date"
                                          name={`${docKey}ExpDate`}
                                          className={`w-full px-3 py-2 border text-sm rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none ${
                                            formErrors?.document?.[
                                              `${docKey}ExpDate`
                                            ]
                                              ? "border-red-500"
                                              : "border-gray-300"
                                          }`}
                                          value={
                                            form.document?.[
                                              `${docKey}ExpDate`
                                            ] || ""
                                          }
                                          onChange={(e) =>
                                            handleFileInputChange(
                                              "date",
                                              `${docKey}ExpDate`,
                                              e.target.value,
                                            )
                                          }
                                          disabled={isDisabled}
                                        />
                                        {formErrors?.document?.[
                                          `${docKey}ExpDate`
                                        ] && (
                                          <div className="text-red-600 text-xs mt-1">
                                            {
                                              formErrors.document[
                                                `${docKey}ExpDate`
                                              ]
                                            }
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </td>

                                  {/* Upload */}
                                  <td className="text-center">
                                    <label className="cursor-pointer inline-flex items-center px-2 py-1 mb-0 bg-blue-600 text-white rounded-md shadow hover:bg-blue-700 transition duration-200">
                                      {!uploadedDocs[docKey]
                                        ? "Upload File"
                                        : "Edit"}
                                      {/* Upload File */}
                                      <input
                                        type="file"
                                        onChange={(e) => {
                                          const file = e.target.files[0];
                                          handleDocumentUpload(docKey, file);
                                        }}
                                        className="hidden"
                                        accept=".jpg,.jpeg,.png,.pdf"
                                      />
                                    </label>
                                    {uploadedDocs[docKey] && (
                                      <>
                                        <span className="text-green-600 text-sm font-medium flex items-center">
                                          <svg
                                            className="w-4 h-4 mr-1"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            viewBox="0 0 24 24"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              d="M5 13l4 4L19 7"
                                            />
                                          </svg>
                                          Uploaded
                                        </span>
                                        {form.document[`${docKey}File`]
                                          ?.previewUrl ? (
                                          <button
                                            type="button"
                                            className="text-blue-600 text-sm underline hover:text-blue-800 ml-2"
                                            onClick={() => openPreview(docKey)}
                                          >
                                            <FaEye />
                                          </button>
                                        ) : (
                                          <a
                                            className="text-blue-600 text-sm underline hover:text-blue-800"
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                            }}
                                            href={
                                              form.document[
                                                `${docKey}previewUrl`
                                              ]
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <FaEye />
                                          </a>
                                        )}
                                      </>
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* Relative Details */}
            <div className="col-md-6">
              <div className="card shadow border-0 rounded-4 custom-card">
                <div className="card-header bg-gradient-primary text-white text-center py-3 rounded-top-4">
                  <h4 className="mb-0 fw-semibold text-white">
                    <i className="fa fa-users" aria-hidden="true"></i>&nbsp;
                    Relative Details <span className="text-red-600">*</span>
                  </h4>
                </div>
                <div className="card-body px-4">
                  <div className="row g-3">
                    {[0, 1].map((idx) => (
                      <div className="col-md-12 mb-5" key={idx}>
                        <h5>
                          Relative {idx + 1} {idx === 0}
                        </h5>

                        <hr
                          style={{
                            width: "100%",
                            height: "2px",
                            margin: "10px 0",
                            backgroundColor: "#ddd",
                          }}
                        />
                        <div className="row g-2">
                          <div className="col-12 col-md-2 mb-3 mb-md-0">
                            <Select
                              classNamePrefix="react-select"
                              name="salutation"
                              placeholder="Select"
                              options={salutationOptions.map((s) => ({
                                value: s,
                                label: s,
                              }))}
                              value={
                                (form.relatives[idx] || {}).salutation
                                  ? {
                                      value: form.relatives[idx].salutation,
                                      label: form.relatives[idx].salutation,
                                    }
                                  : null
                              }
                              onChange={(selectedOption) =>
                                handleRelativeChange(idx, {
                                  target: {
                                    name: "salutation",
                                    value: selectedOption?.value || "",
                                  },
                                })
                              }
                              isDisabled={isDisabled}
                            />
                            {formErrors.relatives &&
                              formErrors.relatives[idx] &&
                              formErrors.relatives[idx].salutation && (
                                <div className="text-danger small mt-1">
                                  {formErrors.relatives[idx].salutation}
                                </div>
                              )}
                          </div>
                          <div className="col-12 col-md-4 mb-3 mb-md-0">
                            <input
                              type="text"
                              className={`form-control form-control-sm input-custom ${
                                formErrors.relatives?.[idx]?.name
                                  ? "is-invalid"
                                  : ""
                              }`}
                              placeholder="Enter Name"
                              name="name"
                              value={(form.relatives[idx] || {}).name || ""}
                              onChange={(e) => handleRelativeChange(idx, e)}
                              onKeyDown={(e) => {
                                const allowedKeys = /^[a-zA-Z\s]$/;

                                // Allow control keys like Backspace, Arrow keys, Tab, etc.
                                if (
                                  e.key.length === 1 && // Only filter printable characters
                                  !allowedKeys.test(e.key)
                                ) {
                                  e.preventDefault(); // Block any character that is not a letter or space
                                }
                              }}
                              disabled={isDisabled}
                            />

                            {formErrors.relatives &&
                              formErrors.relatives[idx] &&
                              formErrors.relatives[idx].name && (
                                <div className="text-danger small mt-1">
                                  {formErrors.relatives[idx].name}
                                </div>
                              )}
                          </div>
                          <div className="col-12 col-md-3 mb-3 mb-md-0">
                            <Select
                              classNamePrefix="react-select"
                              name="relation"
                              placeholder="Select Relation"
                              options={relationOptions}
                              value={
                                relationOptions.find(
                                  (opt) =>
                                    opt.value === form.relatives[idx]?.relation,
                                ) || null
                              }
                              onChange={(selectedOption) =>
                                handleRelativeChange(idx, {
                                  target: {
                                    name: "relation",
                                    value: selectedOption?.value || "",
                                  },
                                })
                              }
                              isDisabled={isDisabled}
                            />
                            {formErrors.relatives &&
                              formErrors.relatives[idx] &&
                              formErrors.relatives[idx].relation && (
                                <div className="text-danger small mt-1">
                                  {formErrors.relatives[idx].relation}
                                </div>
                              )}
                          </div>
                          <div className="col-12 col-md-3 mb-3 mb-md-0">
                            <input
                              type="text"
                              inputMode="numeric"
                              pattern="\d{12}"
                              maxLength={12}
                              className={`form-control form-control-sm input-custom ${
                                formErrors.relatives?.[idx]?.phone
                                  ? "is-invalid"
                                  : ""
                              }`}
                              placeholder="Enter Phone No."
                              name="phone"
                              value={(form.relatives[idx] || {}).phone || ""}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,12}$/.test(value)) {
                                  handleRelativeChange(idx, e);
                                }
                              }}
                              disabled={isDisabled}
                            />
                            {formErrors.relatives &&
                              formErrors.relatives[idx] &&
                              formErrors.relatives[idx].phone && (
                                <div className="text-danger small mt-1">
                                  {formErrors.relatives[idx].phone}
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    ))}
                    {formErrors.relativesError && (
                      <div className="text-danger small mt-2">
                        {formErrors.relativesError}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Booking Details */}
            <div className="col-md-12">
              <div className="card shadow border-0 rounded-4 custom-card">
                <div className="card-header bg-gradient-primary text-white text-center py-3 rounded-top-4">
                  <h4 className="mb-0 fw-semibold text-white">
                    <i className="fa fa-book" aria-hidden="true"></i>&nbsp;
                    Fee's Details
                  </h4>
                </div>
                <div className="card-body px-4">
                  <div className="row g-3">
                    <div className="col-md-12">
                      <div
                        style={{
                          border: "1px solid #e0e0e0",
                          padding: "15px",
                          borderRadius: "5px",
                          backgroundColor: "#f9f9f9",
                        }}
                      >
                        {/* Registration Fees */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "10px",
                          }}
                        >
                          <div>
                            <span style={{ fontWeight: "bold", color: "#333" }}>
                              Registration Fees
                            </span>
                          </div>
                          <div style={{ color: "#2e7d32" }}>
                            ₹{payment.reg_rate || 0}
                          </div>
                        </div>
                        {/* Conditional Fees: Follow-up OR Consultation */}
                        {parseFloat(payment.FOLLOWUP || 0) > 0 ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "10px",
                            }}
                          >
                            <div>
                              <span style={{ color: "#555" }}>
                                Follow-up Fees
                              </span>
                            </div>
                            <div style={{ color: "#757575" }}>
                              ₹{payment.FOLLOWUP}
                            </div>
                          </div>
                        ) : parseFloat(payment.CONSULT || 0) > 0 ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "10px",
                            }}
                          >
                            <div>
                              <span style={{ color: "#555" }}>
                                Consultation Fees
                              </span>
                            </div>
                            <div style={{ color: "#757575" }}>
                              ₹{payment.CONSULT}
                            </div>
                          </div>
                        ) : null}
                        <hr
                          style={{
                            borderTop: "1px dashed #ccc",
                            marginTop: "15px",
                            marginBottom: "10px",
                          }}
                        />
                        {/* Total Fees */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <span style={{ fontWeight: "bold", color: "#333" }}>
                            Total Fees
                          </span>
                          <div style={{ fontWeight: "bold", color: "#d32f2f" }}>
                            ₹{totalAmount}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* BOTTOM BUTTONS */}
                <div
                  className="d-flex justify-content-end gap-3 bg-white py-3 px-4 border-top shadow-sm position-fixed w-100"
                  style={{
                    bottom: 0,
                    zIndex: 50,
                    left: 0,
                  }}
                >
                  {/* Edit Mode Buttons */}
                  {mode === "edit" && (
                    <>
                      <button
                        className="btn btn-primary px-2 py-2 rounded-pill shadow-sm"
                        onClick={handleGotoDashboard}
                        type="button"
                      >
                        <i className="fas fa-arrow-left me-2"></i>Back to
                        Dashboard
                      </button>
                      <button
                        type="button"
                        onClick={async () => {
                          const isValid = await validateForm();
                          if (isValid) {
                            setMode("preview");
                          } else {
                            toast.error("Please fill all the fields.");
                          }
                        }}
                        className="btn btn-primary px-4 py-2 rounded-pill shadow-sm"
                        disabled={isSubmitting}
                      >
                        <i className="fas fa-eye me-2"></i>Preview
                      </button>
                    </>
                  )}

                  {/* Preview Mode Buttons */}
                  {mode === "preview" && (
                    <>
                      <button
                        type="button"
                        className="btn btn-outline-secondary bg-yellow-400 text-black px-4"
                        onClick={() => setMode("edit")}
                        disabled={isSubmitting}
                      >
                        <i className="fas fa-edit me-2"></i>Edit
                      </button>
                      <button
                        type="submit"
                        onClick={handleSubmit}
                        className="btn bg-green-500 text-white px-4 py-2 rounded-pill shadow-sm custom-hover"
                        disabled={isSubmitting}
                      >
                        <i className="fas fa-check me-2"></i>
                        {isSubmitting ? "Loading..." : "Pay Now"}
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <Footer />

      {selectedOrder && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden">
            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center text-white">
                  <div className="flex items-center justify-center w-10 h-10 bg-white bg-opacity-20 rounded-full mr-3">
                    <i className="fas fa-credit-card text-black text-lg"></i>
                  </div>
                  <h2 className="text-xl font-bold text-white">
                    Complete Payment
                  </h2>
                </div>
                <button
                  onClick={() => {
                    setSelectedOrder(null);
                    navigate("/appointment-status");
                  }}
                  className="text-blue-200 hover:text-white transition-colors duration-200"
                  aria-label="Close payment modal"
                >
                  <i className="fas fa-times text-lg"></i>
                </button>
              </div>
            </div>

            <div className="p-6">
              <div className="bg-gradient-to-r from-gray-50 to-blue-50 rounded-xl p-5 mb-6 border border-gray-100">
                <div className="space-y-4">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600 font-medium">
                      Booking No:
                    </span>
                    <span className="font-bold text-gray-800">
                      {bookingAmountInfo.BOOKING_NO}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600 font-medium">Order ID:</span>
                    <span className="font-mono text-sm bg-white px-2 py-1 rounded border">
                      {bookingAmountInfo.ORDER_ID}
                    </span>
                  </div>
                  <div className="border-t pt-4 mt-4">
                    <div className="flex justify-between items-center">
                      <span className="text-gray-700 font-semibold text-lg">
                        Amount:
                      </span>
                      <div className="text-right">
                        <div className="text-3xl font-bold text-green-600">
                          ₹
                          {Number(bookingAmountInfo.REGISTRATION_AMT).toFixed(
                            2,
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex justify-between gap-4 mb-4">
                <button
                  onClick={() => {
                    setSelectedOrder(null);
                    navigate("/appointment-status");
                  }}
                  className="w-1/2 bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-black py-4 px-6 rounded-xl font-bold text-lg transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105 active:scale-95"
                >
                  <i className="fas fa-clock mr-2"></i>
                  Pay Later
                </button>

                {/* <button
                  onClick={handleProceedToPayment}
                  className="w-1/2 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white py-4 px-6 rounded-xl font-bold text-lg transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105 active:scale-95"
                >
                  <i className="fas fa-credit-card mr-2"></i>
                  Pay Now
                </button> */}

                <button
                  onClick={handleProceedToPayment}
                  disabled={isPaying}
                  className={`w-1/2 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white py-4 px-6 rounded-xl font-bold text-lg transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105 active:scale-95
    ${
      isPaying
        ? "bg-gray-400 cursor-not-allowed"
        : "bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700"
    }
  `}
                >
                  {isPaying ? (
                    <span className="flex items-center justify-center">
                      <span className="animate-spin h-4 w-4 mr-2 border-2 border-white border-t-transparent rounded-full" />
                      Processing...
                    </span>
                  ) : (
                    <>
                      <i className="fas fa-shield-alt mr-2"></i>
                      Pay Now
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AddPatient;
